import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	Paper,
	Button,
	CircularProgress,
	Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const STORE_ITEMS_API = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/get-store-items?type=in_stock`;

const InStockStore = () => {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		async function fetchItems() {
			setLoading(true);
			setError("");
			try {
				const res = await axios.get(STORE_ITEMS_API);
				const data = res.data;
				if (res.status === 200 && data.items) {
					setItems(data.items);
				} else {
					setError(data.error || "Failed to load in-stock items.");
				}
			} catch (err) {
				setError("Failed to load in-stock items.");
			}
			setLoading(false);
		}
		fetchItems();
	}, []);

	if (loading)
		return (
			<Box sx={{ textAlign: "center", mt: 4 }}>
				<CircularProgress />
			</Box>
		);
	if (error)
		return (
			<Box sx={{ textAlign: "center", mt: 4 }}>
				<Typography color="error">{error}</Typography>
			</Box>
		);

	return (
		<Box sx={{ maxWidth: 700, mx: "auto", mt: 4 }}>
			<Typography variant="h4" mb={3}>
				In-Stock Store Items
			</Typography>
			{items.length === 0 ? (
				<Typography>No in-stock items available.</Typography>
			) : (
				items.map((item) => (
					<Paper key={item.id} sx={{ p: 2, mb: 2 }}>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
						>
							<Typography variant="h6">{item.title}</Typography>
							<Chip label="In Stock" color="success" />
						</Box>
						<Typography variant="body1" mb={1}>
							{item.description}
						</Typography>
						<Typography variant="subtitle1" mb={1}>
							${(item.price_cents / 100).toFixed(2)}
						</Typography>
						{item.seasons && item.seasons.name && (
							<Typography variant="body2" color="text.secondary">
								Season: {item.seasons.name}
							</Typography>
						)}
						{item.store_item_plants && item.store_item_plants.length > 0 && (
							<Box mt={1}>
								<Typography variant="body2" fontWeight="bold">
									Plants Included:
								</Typography>
								<ul>
									{item.store_item_plants.map((sip) => (
										<li key={sip.plant_id}>
											{sip.plants?.plant_name || "Unnamed Plant"}{" "}
											{sip.quantity_estimate
												? `(${sip.quantity_estimate})`
												: ""}
										</li>
									))}
								</ul>
							</Box>
						)}
						<Button
							variant="contained"
							sx={{ mt: 2 }}
							onClick={() => navigate(`/store/${item.id}`)}
						>
							View Details
						</Button>
					</Paper>
				))
			)}
		</Box>
	);
};

export default InStockStore;
